export default "__VITE_ASSET__DPdP9bC9__"